import { useState } from 'react';

interface UseFileParserResult {
  text: string;
  loading: boolean;
  error: string | null;
  parseFile: (file: File) => Promise<void>;
}

export const useFileParser = ({
  maxTextLength = Infinity,
}: {
  maxTextLength?: number;
} = {}): UseFileParserResult => {
  const [text, setText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const parseFile = async (file: File) => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append('file', file);
      formData.append('maxTextLength', maxTextLength?.toString() ?? '');

      const response = await fetch('/api/readFile', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed');
      }

      const data = await response.json();
      setText(data.text);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return {
    text,
    loading,
    error,
    parseFile,
  };
};
